export const HOMEPAGE_BANNER_UNREGISTERED_REF = 'banner_Homepage';
export const HOMEPAGE_FAQ_UNREGISTERED_REF = 'FAQ_Homepage';
export const HOMEPAGE_BENEFITS_UNREGISTERED_REF = 'benefits_Homepage';
export const HOMEPAGE_SIGNUPCTA_UNREGISTERED_REF = 'signupCTA_Homepage';
export const HEADER_KYC = 'Credit';
export const JOINASABRAND_SIGNUPCTA_UNREGISTERED_REF = 'signupCTA_JoinAsABrand';
export const JOINASABRAND_FAQ_UNREGISTERED_REF = 'FAQ_joinAsABrand';
export const JOINASABRAND_FEATUREDBRANDS_UNREGISTERED_REF = 'FeaturedBrands_joinAsABrand';
